import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import "./App.css";
import AppRoutes from "./pages/routes";
import LoadingScreen from "./loading/loading";
import { useProfile } from "./context/ProfileContext/ProfileUser/ProfileUserContext";
import Registration from "./pages/registrationProfile";
import { Navigate, useLocation } from "react-router-dom";

function App() {
  const { logout } = useAuth0();
  const location = useLocation();

  const { profile, loading, error, refreshProfile } = useProfile();

  if (loading || !profile) {
    return <LoadingScreen />;
  }

  if (
    profile?.data.address === undefined &&
    location.pathname !== "/completar-perfil"
  ) {
    return <Navigate to="/completar-perfil" replace />;
  }

  return <AppRoutes />;
}

export default withAuthenticationRequired(App);
